// config/catalog.js
export const CATALOG = [
  {
    id: 'sku001',
    name: 'Nitrile Exam Gloves (Box of 100)',
    category: 'PPE',
    manufacturer: 'GloveSafe USA',
    unit: '100 gloves',
    emoji: '🧤',
    gpo: 24.50,
    dist: 19.80,
    direct: 12.90,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku002',
    name: 'N95 Respirator Masks (Box of 20)',
    category: 'PPE',
    manufacturer: 'RespiTech America',
    unit: '20 masks',
    emoji: '😷',
    gpo: 42.00,
    dist: 34.50,
    direct: 22.00,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku003',
    name: 'Surgical Gowns Level 3 (Case of 50)',
    category: 'PPE',
    manufacturer: 'MediWear USA',
    unit: '50 gowns',
    emoji: '🥼',
    gpo: 185.00,
    dist: 152.00,
    direct: 98.00,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku004',
    name: 'Face Shields (Box of 25)',
    category: 'PPE',
    manufacturer: 'SafeView Medical',
    unit: '25 shields',
    emoji: '🛡️',
    gpo: 38.00,
    dist: 31.00,
    direct: 19.50,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku005',
    name: 'Surgical Suture Kit 4-0 Vicryl',
    category: 'Surgical',
    manufacturer: 'DemeTech Corp',
    unit: '12 sutures',
    emoji: '🪡',
    gpo: 156.00,
    dist: 128.00,
    direct: 82.00,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku006',
    name: 'Lisinopril 10mg (Bottle of 90)',
    category: 'Pharma',
    manufacturer: 'Oxford Pharmaceuticals',
    unit: '90 tablets',
    emoji: '💊',
    gpo: 45.00,
    dist: 38.00,
    direct: 12.00,
    origin: 'USA',
    dscsa: true
  },
  {
    id: 'sku007',
    name: 'Metformin 500mg (Bottle of 180)',
    category: 'Pharma',
    manufacturer: 'Oxford Pharmaceuticals',
    unit: '180 tablets',
    emoji: '💊',
    gpo: 38.00,
    dist: 32.00,
    direct: 9.00,
    origin: 'USA',
    dscsa: true
  },
  {
    id: 'sku008',
    name: 'Atorvastatin 20mg (Bottle of 90)',
    category: 'Pharma',
    manufacturer: 'Oxford Pharmaceuticals',
    unit: '90 tablets',
    emoji: '💊',
    gpo: 78.00,
    dist: 65.00,
    direct: 18.00,
    origin: 'USA',
    dscsa: true
  },
  {
    id: 'sku009',
    name: 'Amoxicillin 500mg (Bottle of 30)',
    category: 'Pharma',
    manufacturer: 'Oxford Pharmaceuticals',
    unit: '30 capsules',
    emoji: '💊',
    gpo: 28.00,
    dist: 23.50,
    direct: 8.50,
    origin: 'USA',
    dscsa: true
  },
  {
    id: 'sku010',
    name: 'Omeprazole 20mg (Bottle of 90)',
    category: 'Pharma',
    manufacturer: 'Oxford Pharmaceuticals',
    unit: '90 capsules',
    emoji: '💊',
    gpo: 52.00,
    dist: 43.00,
    direct: 14.00,
    origin: 'USA',
    dscsa: true
  },
  {
    id: 'sku011',
    name: 'Digital Thermometer (Unit)',
    category: 'Devices',
    manufacturer: 'MediTech Diagnostics',
    unit: '1 unit',
    emoji: '🌡️',
    gpo: 12.50,
    dist: 10.25,
    direct: 6.80,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku012',
    name: 'Blood Pressure Monitor',
    category: 'Devices',
    manufacturer: 'VitalCheck USA',
    unit: '1 unit',
    emoji: '🩺',
    gpo: 89.00,
    dist: 73.00,
    direct: 48.00,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku013',
    name: 'Pulse Oximeter',
    category: 'Devices',
    manufacturer: 'OxyMed Systems',
    unit: '1 unit',
    emoji: '📟',
    gpo: 45.00,
    dist: 37.00,
    direct: 24.00,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku014',
    name: 'Gauze Pads 4x4 (Box of 100)',
    category: 'Med/Surg',
    manufacturer: 'WoundCare America',
    unit: '100 pads',
    emoji: '🩹',
    gpo: 18.50,
    dist: 15.25,
    direct: 9.80,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku015',
    name: 'IV Catheter 20G (Box of 50)',
    category: 'Med/Surg',
    manufacturer: 'AccessMed USA',
    unit: '50 catheters',
    emoji: '💉',
    gpo: 67.00,
    dist: 55.00,
    direct: 36.00,
    origin: 'USA',
    dscsa: false
  },
  {
    id: 'sku016',
    name: 'Alcohol Prep Pads (Box of 200)',
    category: 'Med/Surg',
    manufacturer: 'SteriSwab Inc',
    unit: '200 pads',
    emoji: '🧼',
    gpo: 14.00,
    dist: 11.50,
    direct: 7.50,
    origin: 'USA',
    dscsa: false
  }
];

export const CATALOG_CATEGORIES = ['All', 'PPE', 'Pharma', 'Devices', 'Med/Surg', 'Surgical'];